import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import { Box } from "@chakra-ui/react";
import CoreService from "../../../services/CoreService";
import LocalStorageService from "../../../services/LocalStorageService";

import HistoryGridButtonStrip from "./HistoryGridButtonStrip";


import GridLayout from "../../../models/GridLayout";



const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";

const divStyle = {
  width: "100%",
  height: "calc(45vh)",

  margin: "5px",
  //border: '5px solid black'
};

export default class HistoryGrid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      formattedGridSchema: [],
      schema: null,
      gridData: [],
      userLayout: '',
      isWorkflowEnabled: false
    };

    this.coreService = new CoreService();
    this.localStorageService = new LocalStorageService();

    this.refreshData = this.refreshData.bind(this);
    this.refreshGridSchema = this.refreshGridSchema.bind(this);
    this.onExportGridToCsvRequest = this.onExportGridToCsvRequest.bind(this);
    this.onSaveLayoutRequest = this.onSaveLayoutRequest.bind(this);
    this.onResetLayoutRequest = this.onResetLayoutRequest.bind(this);
    this.onRestoreLayoutRequest = this.onRestoreLayoutRequest.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onDownloadAsJsonRequest = this.onDownloadAsJsonRequest.bind(this);
    this.onDownloadAsStarJsonRequest = this.onDownloadAsStarJsonRequest.bind(this);
    this.onUploadAsJsonRequest = this.onUploadAsJsonRequest.bind(this);
    this.onUploadDimensionsAsJsonRequest = this.onUploadDimensionsAsJsonRequest.bind(this);
    this.onFilterChangedEvent = this.onFilterChangedEvent.bind(this);


  }

  async componentDidUpdate(prevProps, prevState) 
  {
    var hasRefreshed = false;
    if (this.props.searchParamsKey !== prevProps.searchParamsKey) 
      {
      // TBD - get grid columns setup
      await this.refreshData();
      this.refreshGridSchema();
      hasRefreshed = true;
    }
    if (this.props.autoRefreshTriggerKey !== prevProps.autoRefreshTriggerKey) 
    {
      if ((this.props.suppressAutoRefresh) || (hasRefreshed)) return; // don't refresh again if we've already refreshed
      await this.refreshData();
    }

  }


  async refreshData() 
  {
    this.setState({ isLoading: true });
    try {
      var schema = this.localStorageService.getSchema(this.props.currentSchemaId);
      var refreshDataResponse = await this.coreService.fetchObservationList(this.props.searchParams, schema?.search ?? {}, this.props.userSession.gcid, this.props.userSession.token);
      if (refreshDataResponse.hasError) {
        this.props.onErrorPageRequest("Error fetching observations. " + refreshDataResponse.messages.join(". "));
        return;
      }
      this.setState({gridData: refreshDataResponse.dataResult });
    }
    finally {
      this.props.onObservationSelectionChanged(null);
      this.setState({ isLoading: false });
    }
  }

  refreshGridSchema() 
  {
    var schema = this.localStorageService.getSchema(this.props.searchParams.schemaId);
    var isWorkflowEnabled = schema?.workflow?.enabled;
    var gridSchema = this.localStorageService.getGridSchema(this.props.searchParams.schemaId);
    var formattedGridSchema = GridLayout.toAgGridLayout(gridSchema.data);
    this.setState({ isWorkflowEnabled: isWorkflowEnabled, formattedGridSchema: formattedGridSchema });
    if (this.gridApi) this.gridApi.setColumnDefs(formattedGridSchema);
   if (this.gridApi) this.gridApi.setFilterModel(this.props.globalFilterParams);
    var savedColState = JSON.parse(this.localStorageService.getUserProp(this.props.userSession.gcid, this.props.userSession.uid, GRIDCOLSTATE));
    if (savedColState) {
      this.gridColumnApi.applyColumnState({ state: savedColState, applyOrder: true });
      console.log("tried to load colstate")
    }
  }

  onFilterChangedEvent()
  {    var newFilterModel = this.gridApi.getFilterModel();
      this.props.onGlobalFilterParamsChange(newFilterModel, this.props.parentComponent);
  }

  onSelectionChanged() {
    var selectedNodes = this.gridApi.getSelectedNodes();
    var rowData = selectedNodes[0].data;
    console.log("Observation Selection Changed:");
    console.info(rowData);
    this.props.onObservationSelectionChanged(rowData);
  }

  // #region AgGrid functions

  onEditGridReady = (params) => {
    this.gridApi = params.api;

    this.gridColumnApi = params.columnApi;

  };

  onGridReady = (params) => {
    this.gridApi = params.api;

    this.gridColumnApi = params.columnApi;
    var savedColState = JSON.parse(this.localStorageService.getUserProp(this.props.userSession.gcid, this.props.userSession.uid, GRIDCOLSTATE));
    if (savedColState) {
      this.gridColumnApi.applyColumnState({ state: savedColState, applyOrder: true });
      console.log("tried to load colstate")
    }
    this.gridApi.sizeColumnsToFit();
    if (this.props.globalFilterParams)
      {
        this.gridApi.setFilterModel(this.props.globalFilterParams);
      }
  };



  // #endregion AgGrid functions

  async onDownloadAsJsonRequest(all, isFlat) {
    var requestData = (all) ? this.state.gridData : null;
    this.props.onDownloadAsJsonRequest(requestData, isFlat);
  }

  async onDownloadAsStarJsonRequest() {
    this.props.onDownloadAsStarJsonRequest(this.state.gridData);
  }

  async onUploadAsJsonRequest() {
    await this.props.onUploadAsJsonRequest(this.state.gridData);
  }

  async onUploadDimensionsAsJsonRequest()
  {
    await this.props.onUploadDimensionsAsJsonRequest();
  }

  // grid-based button functions
  onExportGridToCsvRequest() 
  {
    const saveParams = {
      allColumns: true,
      onlySelected: false,
      onlySelectedAllPages: false,
      skipHeader: false,
    };
    this.gridApi.exportDataAsCsv(saveParams);
  }


  onSaveLayoutRequest() 
  {
    var newGridColState = this.gridColumnApi.getColumnState();
    this.localStorageService.setUserProp(this.props.userSession.gcid, this.props.userSession.uid, GRIDCOLSTATE, JSON.stringify(newGridColState));
    this.props.onToastRequest("success", "Your current layout has been saved.")
  }

  onResetLayoutRequest() 
  {
    this.gridColumnApi.resetColumnState();
    this.gridColumnApi.resetColumnGroupState();
    //this.gridApi.setSortModel(null);
    //this.gridApi.setFilterModel(null);
    this.props.onToastRequest("success", "Your current layout has been reset to the default layout.")
  }

  onRestoreLayoutRequest() 
  {
    var savedColState = JSON.parse(this.localStorageService.getUserProp(this.props.userSession.gcid, this.props.userSession.uid, GRIDCOLSTATE));
    if (savedColState) {
      this.gridColumnApi.applyColumnState({ state: savedColState, applyOrder: true });
      //this.gridColumnApi.setColumnState(savedColState);
      this.props.onToastRequest("success", "Your saved layout has been restored.")
      this.setState({
        userLayout: savedColState
      })
    }
    else {
      this.props.onToastRequest("error", "No saved layout was found!")
    }
  }


  render() 
  {

    const gridData = this.state.gridData ? this.state.gridData : [{}];

    return (
      <Box>

        <HistoryGridButtonStrip
          userSession={this.props.userSession}
          isLoading={this.state.isLoading}
          onToastRequest={this.props.onToastRequest}
          onMsgBoxRequest={this.props.onMsgBoxRequest}
          onErrorPageRequest={this.props.onErrorPageRequest}
          onExportGridToCsvRequest={this.onExportGridToCsvRequest}
          currentSchemaId={this.props.currentSchemaId}
          isWorkflowEnabled={this.state.isWorkflowEnabled}
          currentObservation={this.props.currentObservation}
          onShowUserImageBox={this.props.onShowUserImageBox}
          onShowUserDocBox={this.props.onShowUserDocBox}
          onShowShareBox={this.props.onShowShareBox}
          onShowPdfReport={this.props.onShowPdfReport}
          onResendSubscriptionNotificationsRequest={this.props.onResendSubscriptionNotificationsRequest}
          onDownloadAsJsonRequest={this.onDownloadAsJsonRequest}
          onDownloadAsStarJsonRequest={this.onDownloadAsStarJsonRequest}
          onUploadAsJsonRequest={this.onUploadAsJsonRequest}
          onUploadDimensionsAsJsonRequest={this.onUploadDimensionsAsJsonRequest}
          onSaveLayoutRequest={this.onSaveLayoutRequest}
          onResetLayoutRequest={this.onResetLayoutRequest}
          onRestoreLayoutRequest={this.onRestoreLayoutRequest}
          schemaReports={this.props.schemaReports}
          onVoidRequest={this.props.onVoidRequest}
          onCopyRequest={this.props.onCopyRequest}
          onViewReadOnlyRequest={this.props.onViewReadOnlyRequest}
          onUpdateRequest={this.props.onUpdateRequest}
          onDuplicateRequest={this.props.onDuplicateRequest}
          onWorkflowStepRequest={this.props.onWorkflowStepRequest}
          onRefreshDataRequest={this.refreshData}
          parentComponent={this.props.parentComponent}


        />
        <div className="ag-theme-balham" style={divStyle}>
          <AgGridReact
            maintainColumnOrder={true}

            rowSelection="single"
            enableRangeSelection={false}
            pagination={true}
            columnDefs={this.state.formattedGridSchema}
            rowData={gridData}
            animateRows={true}
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
            onRowClicked={this.onSelectionChanged}
            onFilterChanged={this.onFilterChangedEvent}
          />
        </div>



      </Box>

    );
  }
}
